import React from 'react'

import { theme } from '@acorns/grove'
import styled from 'styled-components'

const DateDividerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  width: 100%;
`

const DateDividerText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${theme.colors.primaryStoneLight};
  text-align: center;
`

export const DateDivider = ({ date }: { date: string }) => {
  return (
    <DateDividerContainer>
      <DateDividerText>{date}</DateDividerText>
    </DateDividerContainer>
  )
}
